import { Product } from './types';

export const soundProducts: Product[] = [
  {
    id: 'SP1',
    numericId: 601,
    name: '便携式蓝牙音箱 SP1',
    description: '',
    price: '4,999₽',
    image: '/images/sound/scene/SP1/SP1-main.png',
    cardImage: '/images/sound/SP1.png',
    gallery: [
      {
        src: '/images/sound/scene/SP1/SP1场景图1.png',
      },
      {
        src: '/images/sound/scene/SP1/SP1场景图2.png',
      },
      {
        src: '/images/sound/scene/SP1/SP1场景图3.png',
      },
      {
        src: '/images/sound/scene/SP1/SP1场景图4.png',
      }
    ],
    features: [
        "4D重鼓环绕音效，TWS互联，0.2S超低延迟",
        "采用双10W全频双磁喇叭，声音穿透力强，覆盖范围广，音色浑厚饱满有力",
        "三防设计，双色注塑工艺",
        "高能锂电池，中等音量可连续播放8～12H"
      ],
    specifications: {
        "产品尺寸": "170*69*49mm",
        "产品净重": "418g",
        "外壳材质": "TPU、ABS",
        "蓝牙版本": "4.2",
        "失真度": "≦1%",
        "峰值功率": "10W*2",
        "频率响应": "80Hz～20KHz",
        "电池容量": "3600mAh",
        "充电接口": "Type-c",
        "其他接口": "TF卡 / AUX音频",
        "防水等级": "IPX5"
      }
  },
  {
    id: 'SP2',
    numericId: 602,
    name: '便携式蓝牙音箱 SP2',
    description: '',
    price: '3,899₽',
    image: '/images/sound/scene/SP2/SP2-main.png',
    cardImage: '/images/sound/SP2.png',
    gallery: [
      {
        src: '/images/sound/scene/SP2/SP2场景图1.png',
      },
      {
        src: '/images/sound/scene/SP2/SP2场景图2.png',
      },
      {
        src: '/images/sound/scene/SP2/SP2场景图3.png',
      },
      {
        src: '/images/sound/scene/SP2/SP2场景图4.png',
      }
    ],
    features: [
        "专业级调音，录音棚级DSP音效，ES动态低频增强技术",
        "全密封多重保护设计，全新户外三防体验",
        "内置高清降噪麦克风，支持免提通话",
        "TWS互联，0.2S超低延迟"
      ],
    specifications: {
        "产品尺寸": "115*⌀80mm",
        "产品净重": "355g",
        "外壳材质": "TPU、ABS",
        "蓝牙版本": "4.2",
        "失真度": "≦1%",
        "峰值功率": "8W*2",
        "频率响应": "80Hz～18KHz",
        "电池容量": "2000mAh",
        "充电接口": "Type-c",
        "其他接口": "TF卡 / AUX音频",
        "防水等级": "IPX5"
      }
  },
  {
    id: 'SP3',
    numericId: 603,
    name: '便携式蓝牙音箱 SP3',
    description: '',
    price: '5,399₽',
    image: '/images/sound/scene/SP3/SP3-main.png',
    cardImage: '/images/sound/SP3.png',
    gallery: [
      {
        src: '/images/sound/scene/SP3/SP3场景图1.png',
      },
      {
        src: '/images/sound/scene/SP3/SP3场景图2.png',
      },
      {
        src: '/images/sound/scene/SP3/SP3场景图3.png',
      },
      {
        src: '/images/sound/scene/SP3/SP3场景图4.png',
      }
    ],
    features: [
        "高能锂电池，90%音量可连续播放6～9H，SOS户外呼救功能，一键应急警报",
        "三防设计，双色注塑工艺",
        "采用双15W20芯强磁喇叭，糅合橡胶振膜共振，腔体发声沉稳",
        "采用炬力芯片，智能调控高中低音区时的喇叭振膜频率使音阶保持清晰"
      ],
    specifications: {
        "产品尺寸": "196*⌀80mm",
        "产品净重": "726g",
        "外壳材质": "TPU、ABS",
        "蓝牙版本": "4.2",
        "失真度": "≦1%",
        "峰值功率": "15W*2",
        "频率响应": "70Hz～18KHz",
        "电池容量": "4400mAh",
        "充电接口": "Type-c",
        "其他接口": "TF卡 / AUX音频",
        "防水等级": "IPX5"
      }
  },
  {
    id: 'SM1',
    numericId: 604,
    name: '麦克风输入式蓝牙音箱 SM1',
    description: '',
    price: '21,999₽',
    image: '/images/sound/scene/SM1/SM1-main.png',
    cardImage: '/images/sound/SM1.png',
    gallery: [
      {
        src: '/images/sound/scene/SM1/SM1场景图1.png',
      },
      {
        src: '/images/sound/scene/SM1/SM1场景图2.png',
      },
      {
        src: '/images/sound/scene/SM1/SM1场景图3.png',
      },
      {
        src: '/images/sound/scene/SM1/SM1场景图4.png',
      }
    ],
    features: [
        "双炫彩光圈，5种震撼灯效，高能锂电池，持续6～8小时播放",
        "舞台级震撼声浪，采用2*3寸低音喇叭，穿透力强",
        "背带式便携设计，轻松携带",
        "蓝牙5.0，连接迅速稳定，兼容99%的蓝牙设备"
      ],
    specifications: {
        "产品尺寸": "328*161*145mm",
        "产品净重": "2750g",
        "外壳材质": "ABS",
        "蓝牙版本": "5.0",
        "峰值功率": "40W",
        "信噪比": "≥90db",
        "电池容量": "4000mAh",
        "充电接口": "Type-c",
        "其他接口": "USB / TF卡 / AUX音频 / OUT输出 / 乐器孔 / 直播孔"
      }
  },
  {
    id: 'SM2',
    numericId: 605,
    name: '麦克风输入式蓝牙音箱 SM2',
    description: '',
    price: '49,999₽',
    image: '/images/sound/scene/SM2/SM2主图.jpg',
    cardImage: '/images/sound/SM2.png',
    gallery: [
      {
        src: '/images/sound/scene/SM2/SM2场景图1.png',
      },
      {
        src: '/images/sound/scene/SM2/SM2场景图2.png',
      },
      {
        src: '/images/sound/scene/SM2/SM2场景图3.png',
      },
      {
        src: '/images/sound/scene/SM2/SM2场景图4.png',
      }
    ],
    features: [
        "古典美学外观设计，木质与皮革的完美搭配",
        "齿盘金属调音按钮，调音流畅细致，拉丝金属操作面板，质感高雅",
        "三频喇叭，震撼音效，高中低音独立调节功能设计",
        "HiFi级音效，支持更多设备接入"
      ],
    specifications: {
        "产品尺寸": "412*303*226mm",
        "产品净重": "11.02Kg",
        "外壳材质": "木、皮革、金属",
        "蓝牙版本": "5.0",
        "峰值功率": "150W",
        "信噪比": "≥90db",
        "电池容量": "10000mAh",
        "充电接口": "DC 28V",
        "其他接口": "USB / TF卡 / AUX音频 / OUT输出 / 乐器孔 / 直播孔"
      }
  },
  {
    id: 'EH1',
    numericId: 606,
    name: '头戴式蓝牙耳机 EH1',
    description: '',
    price: '6,999₽',
    image: '/images/sound/scene/EH1/EH1_main.jpg',
    cardImage: '/images/sound/EH1.png',
    gallery: [
      {
        src: '/images/sound/scene/EH1/EH1场景图1.png',
      },
      {
        src: '/images/sound/scene/EH1/EH1场景图2.png',
      },
      {
        src: '/images/sound/scene/EH1/EH1场景图3.png',
      },
      {
        src: '/images/sound/scene/EH1/EH1场景图4.png',
      }
    ],
    features: [
        "混合有源降噪±35db，单次充电续航长达70小时",
        "40mm动态驱动为您提供卓越的音质",
        "采用LDAC解码格式，支持HiRes双金标准认证",
        "空间音频，支持双设备连接",
        "4个内置ANC麦克风，支持ENC进行清晰通话"
      ],
    specifications: {
        "喇叭尺寸": "40mm",
        "频率响应": "20Hz～20KHz",
        "麦克风": "4个麦克风",
        "蓝牙版本": "5.4",
        "蓝牙范围": "15M",
        "蓝牙编解码器": "LDAC/SBC/AAC",
        "电池容量": "600mAh",
        "充电接口": "Type-c"
      }
  },
  {
    id: 'EH2',
    numericId: 607,
    name: '头戴式蓝牙耳机 EH2',
    description: '',
    price: '9,699₽',
    image: '/images/sound/scene/EH2/EH2_main.jpg',
    cardImage: '/images/sound/EH2.png',
    gallery: [
      {
        src: '/images/sound/scene/EH2/EH2场景图1.png',
      },
      {
        src: '/images/sound/scene/EH2/EH2场景图2.png',
      },
      {
        src: '/images/sound/scene/EH2/EH2场景图3.png',
      },
      {
        src: '/images/sound/scene/EH2/EH2场景图4.png',
      }
    ],
    features: [
        "混合有源降噪±40db，单次充电续航长达80小时",
        "40mm动态驱动为您提供卓越的音质",
        "采用LDAC解码格式，支持HiRes双金标准认证",
        "空间音频，支持双设备连接",
        "4个内置ANC麦克风，支持ENC进行清晰通话"
      ],
    specifications: {
        "喇叭尺寸": "40mm",
        "频率响应": "20Hz～20KHz",
        "麦克风": "4个麦克风",
        "蓝牙版本": "5.4",
        "蓝牙范围": "15M",
        "蓝牙编解码器": "LDAC/SBC/AAC",
        "电池容量": "600mAh",
        "充电接口": "Type-c"
      }
  },
  {
    id: 'EG1',
    numericId: 608,
    name: '颈戴式蓝牙耳机 EG1',
    description: '',
    price: '2,199₽',
    image: '/images/sound/scene/EG1/EG1_main.jpg',
    cardImage: '/images/sound/EG1.png',
    gallery: [
      {
        src: '/images/sound/scene/EG1/EG1场景图1.png',
      },
      {
        src: '/images/sound/scene/EG1/EG1场景图2.png',
      },
      {
        src: '/images/sound/scene/EG1/EG1场景图3.png',
      },
      {
        src: '/images/sound/scene/EG1/EG1场景图4.png',
      }
    ],
    features: [
        "超低功效，持久续航",
        "ENC智能通话降噪，过滤环境噪音，清晰通话",
        "高动态大动圈单元，独立金属低音管结构",
        "SBC+AAC音频解码",
        "单耳受力小于3g，佩戴无感舒适",
        "律动呼吸灯设计"
      ],
    specifications: {
        "喇叭尺寸": "10mm",
        "频率响应": "20Hz～20KHz",
        "蓝牙版本": "5.3",
        "蓝牙范围": "≥10M",
        "蓝牙编解码器": "SBC/AAC",
        "电池容量": "300mAh",
        "充电接口": "Type-c",
        "防水等级": "IPX5"
      }
  }
]; 